import type { OfflineEntity } from './db'
import { SYNC_ENTITIES } from './syncEntities'

export function entityLabel(entity: OfflineEntity): string {
  return SYNC_ENTITIES[entity]?.label ?? entity
}
